import {getInitialMeta} from "@helpers/HelperInitialPageState";
// Data file for component
///////////////////////////////////////////////////////////////////////////////////////////
import flag from '@baseImg/icons/voltage-icon.webp';

const BG = {
	page: 'Order',
	brandColor: 'color-brand-orange-400',
	height: 'short',
	list: [],
	infoBar: {
		text: '<img src="' + flag + '" alt="Flash sale" title="Flash sale - SuperHosting.BG" width="22" height="22"/> Flash Sale! Запази .BG и .EU заедно и вземи над 50% отстъпка до 11 ноември!',
		buttonText: 'Поръчай',
		buttonUrl: getInitialMeta('siteURL') + 'web-hosting-register-domains.php',
		layout: 'default'
	}
}

///////////////////////////////////////////////////////////////////////////////////////////

const EN = {
	page: 'Order',
	brandColor: 'color-brand-orange-400',
	height: 'short',
	list: [],
	infoBar: {
		text: '<img src="' + flag + '" alt="Flash sale" title="Flash sale - SuperHosting.BG" width="22" height="22"/> Flash Sale! Get .BG & .EU together and save over 50% until November 11!',
		buttonText: 'Order',
		buttonUrl: getInitialMeta('siteURL') + 'web-hosting-register-domains.php',
		layout: 'default'
	}
}

///////////////////////////////////////////////////////////////////////////////////////////

const dataMap = {
	bg: BG,
	en: EN
};
const lang = getInitialMeta('pageLang') ?? 'bg';

///////////////////////////////////////////////////////////////////////////////////////////

export default dataMap[lang];